<template>
  <div>
    <div id="login">
      <div class="login_box">
        <div class="login_box_title" v-if="title_style == 1">
          <div
            class="login_box_title_text1"
            :class="{ login_box_title_text_change1: title_change == 0 }"
            @click="mmdl"
          >
            密码登录
          </div>
          <div
            class="login_box_title_text2"
            :class="{ login_box_title_text_change1: title_change == 1 }"
            @click="dxdl"
          >
            短信登陆
          </div>
          <div class="login_box_title_text3">
            <img
              src="../../public/img/login/close.png"
              alt=""
              class="login_box_title_text3_img login_close"
              @click="login_close"
            />
          </div>
        </div>
        <div class="login_box_title2" v-if="title_style == 2">
          <div class="login_box_title2_text1" id="zcdl2" v-if="title_num == 0">
            账号注册
          </div>
          <div class="login_box_title2_text1" id="czmm2" v-if="title_num == 1">
            忘记密码
          </div>
          <div class="login_box_title2_text1" id="bdsjh2" v-if="title_num == 2">
            绑定手机号
          </div>
          <div class="login_box_title2_text1" id="yqqd2" v-if="title_num == 3">
            请输入邀请信息
          </div>
          <div class="login_box_title2_text1" id="wxdl2" v-if="title_num == 4">
            微信登陆
          </div>
          <div class="login_box_title2_text3">
            <img src="../../public/img/login/close.png" class="login_box_title2_text3_img login_close" @click="login_close"/>
          </div>
        </div>
        <div class="login_weixin" v-if="iswxlogin == 1">
          <img src="../../public/img/login/footer02.png" alt="" />
          <div style="margin-top: 10px">微信扫码，关注公众号即可登录</div>
        </div>
        <div class="login_box_input">
          <div class="login_box_input_input0" v-if="input0_isshow == 1">
            <input type="text" placeholder="请输入手机号码" v-model="sjhm" />
          </div>
          <div
            class="login_box_input_input2"
            style="margin-top: 12px"
            v-if="input2_isshow == 1"
          >
            <input type="text" placeholder="请输入图形验证码" v-model="tuyzm" />
            <img :src="ycodeUrl" alt="" />
          </div>
          <div
            class="login_box_input_input3"
            style="margin-top: 12px"
            v-if="input3_isshow == 1"
          >
            <input type="text" placeholder="请输入短信验证码" v-model="dxyzm" />
            <div class="login_box_input_input3_hqyzm" @click="hqyzm" v-if="js_show">获取验证码</div>
            <div class="login_box_input_input3_hqyzm" v-else>{{js_time}}秒</div>
          </div>
          <div
            class="login_box_input_input1"
            style="margin-top: 12px"
            v-if="input1_isshow == 1"
          >
            <input
              :type="input_type1"
              placeholder="请输入密码"
              id="password"
              v-model="mima"
            />
            <div href="" id="eye" @click="change_input_type(1)">
              <img src="../../public/img/login/eye.png" alt="" />
            </div>
          </div>
          <div
            class="login_box_input_input4"
            style="margin-top: 12px"
            v-if="input4_isshow == 1"
          >
            <input
              :type="input_type2"
              placeholder="请输入密码"
              id="password_zhuce1"
              v-model="qrmm1"
            />
            <div href="" id="eye_zhuce1" @click="change_input_type(2)">
              <img src="../../public/img/login/eye.png" alt="" />
            </div>
          </div>
          <div
            class="login_box_input_input4"
            style="margin-top: 12px"
            v-if="input4_isshow == 1"
          >
            <input
              :type="input_type3"
              placeholder="请输入昵称"
              id="password_zhuce2"
              v-model="qrmm2"
            />
            <div href="" id="eye_zhuce2" @click="change_input_type(3)">
              <img src="../../public/img/login/eye.png" alt="" />
            </div>
          </div>
          <div
            class="login_box_input_input5"
            style="margin-top: 12px"
            v-if="input5_isshow == 1"
          >
            <input
              type="text"
              placeholder="请输入邀请码或邀请人手机号码"
              v-model="yqm_sjh"
            />
          </div>
          <div
            class="login_box_input_input6"
            style="margin-top: 12px"
            v-if="input6_isshow == 1"
          >
            <div class="login_box_input_input6_left">
              <img src="" alt="" id="yaoqing_img" />
            </div>
            <div class="login_box_input_input6_right">
              <div>
                <div id="yaoqing_text1">钱术智投官方</div>
                <div id="yaoqing_text2">邀请你加入钱书</div>
              </div>
            </div>
          </div>
          <div
            class="login_box_input_button1"
            id="yqqd"
            v-if="dl_style == 0"
            @click="dl"
          >
            确定
          </div>
          <div
            class="login_box_input_button1"
            id="bdsjh"
            v-if="dl_style == 1"
            @click="dl"
          >
            登录
          </div>
          <div
            class="login_box_input_button1"
            id="czmm"
            v-if="dl_style == 2"
            @click="dl"
          >
            重置密码
          </div>
        </div>
        <div class="login_box_bottom">
          <div class="login_box_bottom_menu1" v-if="isshow_menu">
            <div class="login_box_bottom_menu11" @click="xczddl">
              <div
                class="login_box_bottom_xczddl"
                :class="{ login_box_bottom_xczddl2: is_xczddl }"
                id="xczddl"
              ></div>
              下次自动登录
            </div>
            <div class="login_box_bottom_menu12">
              <div class="login_box_bottom_menu12_text1" @click="wjmm">
                忘记密码
              </div>
              <div class="login_box_bottom_menu12_text2">|</div>
              <div class="login_box_bottom_menu12_text3" @click="zc">注册</div>
            </div>
          </div>
          <div class="login_disanfang_box" v-if="sfdl">
            <div class="login_disanfang_box_text">第三方账号登录</div>
            <div class="login_disanfang_box_img">
              <img
                src="../../public/img/login/weixin.png"
                alt=""
                id="login_wx"
                @click="login_sf"
              />
            </div>
          </div>
          <div class="login_xieyi_yinsi" v-if="xieyi">
            注册或登录即同意<i class="login_xieyi_yinsi_text1"
              >《钱术智投用户协议》</i
            >&<i class="login_xieyi_yinsi_text2">《隐私保护》</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { passwdlogin,sendCodeLogin,loginMobileCode,registerMobile,forgetPasswd}from '../http/login.js'
// import {getOS} from '../../public/js/os.js'
export default {
  data() {
    return {
      title_style: 1, // 登录title样式  1 标题居左  2  标题居中
      title_num: 0, // 0 账号注册   1忘记密码     2绑定手机号     3请输入邀请信息    4微信登陆
      iswxlogin: 0, // 0 不显示  1 显示
      input0_isshow: 1, // 0不显示  1显示     手机号码
      input1_isshow: 1, // 0不显示  1显示     密码
      input2_isshow: 0, // 0不显示  1显示     图形验证码
      input3_isshow: 0, // 0不显示  1显示     短信验证码
      input4_isshow: 0, // 0不显示  1显示      两次密码
      input5_isshow: 0, // 0不显示  1显示     邀请码或邀请人手机号
      input6_isshow: 0, // 0不显示  1显示     邀请人信息
      dl_style: 0, //登录按钮样式    0 确定   1登录   2重置密码
      is_xczddl: false, //是否下次自动登录
      title_change: 0, //标题样式改变   0 选中 密码登录   1 选中 短信登陆
      isshow_menu: true, //是否显示 下次自动登录  哪一行
      sfdl: true, // 是否显示 第三方登录
      xieyi: true, //是否显示 协议哪一行
      tuyzm: "", //图形验证码
      sjhm: "", //手机号码
      dxyzm: "", //短信验证码
      mima: "", //密码
      qrmm1: "", //确认密码1
      qrmm2: "", //昵称
      yqm_sjh: "", //邀请码或邀请人手机号
      input_type1: "password", //密码框一type
      input_type2: "password", //密码框二type
      input_type3: "password", //密码框三type

      button_type: 0, //当前是啥操作     0密码登录    1短信登陆   2忘记密码   3 注册    4第三方登录  5 输入邀请信息  6 绑定手机号
      telReg: /^1[3|4|5|6|7|8|9]\d{9}$/, //验证手机号的正则
      os:'windows', //当前登录的系统 默认为windows
      ycodeUrl:'',    //图形验证码图片地址
      imgcodekey:'',    //图形验证码。。。
      js_time:60,       //短信验证码60s计时
      js_show:true,       //是否显示验证码计时
    };
  },
  props: {},
  methods: {
    //点击密码框的那个小眼睛
    change_input_type(e) {
      if (e == 1) {
        if (this.input_type1 == "password") {
          this.input_type1 = "text";
        } else if (this.input_type1 == "text") {
          this.input_type1 = "password";
        }
      } else if (e == 2) {
        if (this.input_type2 == "password") {
          this.input_type2 = "text";
        } else if (this.input_type2 == "text") {
          this.input_type2 = "password";
        }
      } else if (e == 3) {
        if (this.input_type3 == "password") {
          this.input_type3 = "text";
        } else if (this.input_type3 == "text") {
          this.input_type3 = "password";
        }
      }
    },
    //初始化所有input
    initinput() {
      this.title_style = 1;
      this.title_num = 0;
      this.iswxlogin = 0;
      this.input0_isshow = 0;
      this.input1_isshow = 0;
      this.input2_isshow = 0;
      this.input3_isshow = 0;
      this.input4_isshow = 0;
      this.input5_isshow = 0;
      this.input6_isshow = 0;
      this.dl_style = 0;
      this.title_change = 0;
      this.is_xczddl = false;
      this.isshow_menu = false;
      this.sfdl = false;
      this.xieyi = false;
      this.tuyzm = "";
      this.sjhm = "";
      this.dxyzm = "";
      this.mima = "";
      this.qrmm1 = "";
      this.qrmm2 = "";
      this.yqm_sjh = "";
      this.button_type = 0;
    },
    //点击下次自动登录
    xczddl() {
      this.is_xczddl = !this.is_xczddl;
    },
    //点击密码登录
    mmdl() {
      this.initinput();
      this.title_change = 0;
      this.input0_isshow = 1;
      this.input1_isshow = 1;
      this.isshow_menu = true;
      this.sfdl = true;
      this.xieyi = true;
      this.button_type = 0;
    },
    //点击短信登陆
    dxdl() {
      this.initinput();
      this.title_change = 1;
      this.input0_isshow = 1;
      this.input2_isshow = 1;
      this.input3_isshow = 1;
      this.isshow_menu = true;
      this.sfdl = true;
      this.xieyi = true;
      this.button_type = 1;
      // console.log(this.title_change);
    },
    //点击忘记密码
    wjmm() {
      this.initinput();
      this.title_style = 2;
      this.title_num = 1;
      this.input0_isshow = 1;
      this.input2_isshow = 1;
      this.input3_isshow = 1;
      this.input1_isshow = 1;
      this.dl_style = 2;
      this.button_type = 2;
    },
    //点击注册
    zc() {

      this.initinput();
      this.title_style = 2;
      this.title_num = 0;
      this.dl_style = 1;
      this.input0_isshow = 1;
      this.input2_isshow = 1;
      this.input3_isshow = 1;
      this.input4_isshow = 1;
      this.xieyi = true;
      this.button_type = 3;
    },
    //点击关闭
    login_close() {
      this.$emit("login_close");
      this.initinput();
      this.title_change = 0;
      this.input0_isshow = 1;
      this.input1_isshow = 1;
      this.isshow_menu = true;
      this.sfdl = true;
      this.xieyi = true;
    },
    //点击微信图标
    login_sf() {
      this.initinput();
      this.title_style = 2;
      this.title_num = 4;
      this.iswxlogin = 1;
      this.dl_style = 4;
      this.button_type = 4;
    },
    //点击登录
    dl() { 
      if (this.button_type == 0) {//0密码登录
        let sjhm = this.sjhm
        let mima = this.mima
        if(!sjhm){
          this.$message.error('请输入手机号码')
          return
        }
        if(!mima){
          this.$message.error('请输入密码')
          return
        }
        if(!(this.telReg.test(sjhm))){
          this.$message.error('请输入正确的手机号')
          return
        }
        let passwd = this.$md5(mima);
        let params = Object.assign({},{mobile:sjhm,passwd,})
        passwdlogin(params).then((res)=>{
          if (res.code == 0) {
						
						this.$store.commit('changeUserinfo', res.data.user_info)
              let platform = this.os 
              let version = this.$store.state.version
              let uid = res.data.user_info.uid
              let last_time = res.data.user_info.last_time
              let params = this.$md5(platform + version + uid + last_time)
						this.$store.commit('setSign', params)
            this.$router.go(0)
					} 
          else {
						console.log(res);
					}
        }).catch((err)=>{
          console.log(err);
        })
      } else if (this.button_type == 1) {//1短信登陆
        let sjhm = this.sjhm
        if(!sjhm){
          this.$message.error('请输入手机号码')
          return
        }
        if(!(this.telReg.test(sjhm))){
          this.$message.error('请输入正确的手机号')
          return
        }
        let code = this.dxyzm
        let params = Object.assign({},{mobile:sjhm,code,})
        loginMobileCode(params).then((res)=>{
          if (res.code == 0) {
						this.$store.commit('changeUserinfo', res.data.user_info)
              let platform = this.os 
              let version = this.$store.state.version
              let uid = res.data.user_info.uid
              let last_time = res.data.user_info.last_time
              let params = this.$md5(platform + version + uid + last_time)
						this.$store.commit('setSign', params)
            this.$router.go(0)
					}else{
            console.log(res);
          }
        }).catch((err)=>{
          console.log(err);
        })
      }
      else if(this.button_type == 2){//2忘记密码
        let sjhm = this.sjhm
        if(!sjhm){
          this.$message.error('请输入手机号码')
          return
        }
        if(!(this.telReg.test(sjhm))){
          this.$message.error('请输入正确的手机号')
          return
        }
        let code = this.dxyzm
        let passwd = this.mima
        let params = Object.assign({},{mobile:sjhm,code,passwd})
        forgetPasswd(params).then((res)=>{
          console.log(res);
        }).catch((err)=>{
          console.log(err);
        })
      }  
      else if(this.button_type == 3){//3 注册
        let sjhm = this.sjhm
        if(!sjhm){
          this.$message.error('请输入手机号码')
          return
        }
        if(!(this.telReg.test(sjhm))){
          this.$message.error('请输入正确的手机号')
          return
        }
        let mima1 = this.qrmm1
        let nick_name = this.qrmm2

        let code = this.dxyzm
        let params = Object.assign({},{mobile:sjhm,code:code,passwd:mima1,system_os:this.os,platform:'pc',nick_name})
        registerMobile(params).then((res)=>{
          console.log(res);
        }).catch((err)=>{
          console.log(err);
        })
        this.initinput();
        this.title_style = 2;
        this.title_num = 3;
        this.dl_style = 0;
        this.input5_isshow = 1;
        this.button_type = 5;
      }  
      else if(this.button_type == 4){//4第三方登录
      }  
      else if(this.button_type == 5){//5 输入邀请信息
      }  
      else if(this.button_type == 6){//6 绑定手机号
      }  
    },
    getOS() {
      var u = navigator.userAgent;
      if (!!u.match(/compatible/i) || u.match(/Windows/i)) {
          return 'windows';
      } else if (!!u.match(/Macintosh/i) || u.match(/MacIntel/i)) {
          return 'macOS';
      } else if (!!u.match(/iphone/i) || u.match(/Ipad/i)) {
          return 'ios';
      } else if (!!u.match(/android/i)) {
          return 'android';
      } else {
          return 'other';
      }
    },
    getYcode(){
      let a = Math.ceil(Math.random()*1000)
      let b = new Date()
      let nowtime = b.getTime()
      let c = `${nowtime}${a}`
      let imgcodekey = this.$md5(c)
      this.imgcodekey = imgcodekey
      this.ycodeUrl = `http://ceshi2.api.qianshu.com/v150/System/imgCode?imgcodekey=${imgcodekey}`
    },
    //点击获取验证码
    hqyzm(){
      let sjhm = this.sjhm
      let tuyzm = this.tuyzm
      if(!sjhm){
        this.$message.error('请输入手机号码')
        return
      }
      if(!(this.telReg.test(sjhm))){
        this.$message.error('请输入正确的手机号')
        return
      }
      if(tuyzm.length != 4){
        this.$message.error('请正确输入图形验证码')
        return
      }
      this.js_show = false
      this.js_time = 60
      this.ksjs()
      let imgcode = tuyzm
      let imgcodekey = this.imgcodekey
      let params = Object.assign({},{mobile:sjhm,imgcode,imgcodekey})
      sendCodeLogin(params).then((res)=>{
        console.log(res);
        if(res.code == 0){
          this.$message.success('发送成功')
        }else{
          this.$message.error(res.msg)
        }
      }).catch((err)=>{
        console.log(err);
      })
    },
    ksjs(){
      let _a = setInterval(() => {
        this.js_time --
        if(this.js_time == 0){
          this.js_show = true
          clearInterval(_a)
        }
      }, 1000);
    }
  },
  mounted(){
    let canshu1 = this.getOS()
    this.os = canshu1
    this.getYcode()
  }
};
</script>

<style scoped>
#login {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.login_box {
  width: 300px;
  /* height: 520px; */
  background-color: #ffffff;
  border-radius: 6px;
  padding: 30px 40px 40px 40px;
}

.login_box_title {
  width: 100%;
  height: 45px;
  border-bottom: 1px solid #f4f4f4;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
}

.login_box_title_text1 {
  width: 72px;
  height: 17px;
  font-size: 18px;
  color: #999;
  cursor: pointer;
}

.login_box_title_text2 {
  width: 72px;
  height: 17px;
  font-size: 18px;
  color: #999;
  cursor: pointer;
}

.login_box_title_text3 {
  width: 96px;
  height: 18px;
  color: #000000;
  text-align: right;
}

.login_box_title_text_change1 {
  font-size: 18px;
  color: #000;
  position: relative;
}

.login_box_title_text_change1:after {
  content: " ";
  display: block;
  width: 72px;
  height: 4px;
  background: #fcad2a;
  border-radius: 3px;
  overflow: hidden;
  margin: 0 auto;
  position: absolute;
  bottom: -30px;
  left: 0;
}

.login_box_title_text3_img {
  width: 19px;
  height: 19px;
  cursor: pointer;
}

.login_box_title2 {
  width: 100%;
  height: 45px;
  border-bottom: 1px solid #f4f4f4;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.login_box_title2_text1 {
  width: 100%;
  height: 17px;
  font-size: 18px;
  color: #999;
  text-align: center;
  cursor: pointer;
}

.login_box_title2_text3 {
  width: 96px;
  height: 18px;
  color: #000000;
  text-align: right;
  position: absolute;
  right: 0;
  top: 0;
}

.login_box_title2_text3_img {
  width: 19px;
  height: 19px;
  cursor: pointer;
}

.login_box_input {
  margin-top: 40px;
}

.login_box_input_input5 {
  width: 300px;
  height: 48px;
  position: relative;
}

.login_box_input_input5 input {
  width: 276px;
  height: 48px;
  background-color: #f7f7f7;
  border-radius: 6px;
  border: solid 1px #f3f3f3;
  padding-left: 24px;
}

.login_box_input_input5 input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #b8b8b8;
}

.login_box_input_input5 input:focus {
  outline: none;
  border: 1px solid #fcad2a;
}

.login_box_input_input0 {
  width: 300px;
  height: 48px;
  position: relative;
}

.login_box_input_input0 input {
  width: 276px;
  height: 48px;
  background-color: #f7f7f7;
  border-radius: 6px;
  border: solid 1px #f3f3f3;
  padding-left: 24px;
}

.login_box_input_input0 input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #b8b8b8;
}

.login_box_input_input0 input:focus {
  outline: none;
  border: 1px solid #fcad2a;
}

.login_box_input_input4 {
  width: 300px;
  height: 48px;
  position: relative;
}

.login_box_input_input4 input {
  width: 276px;
  height: 48px;
  background-color: #f7f7f7;
  border-radius: 6px;
  border: solid 1px #f3f3f3;
  padding-left: 24px;
}

.login_box_input_input4 input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #b8b8b8;
}

.login_box_input_input4 input:focus {
  outline: none;
  border: 1px solid #fcad2a;
}

.login_box_input_input1 {
  width: 300px;
  height: 48px;
  position: relative;
}

.login_box_input_input1 input {
  width: 276px;
  height: 48px;
  background-color: #f7f7f7;
  border-radius: 6px;
  border: solid 1px #f3f3f3;
  padding-left: 24px;
}

.login_box_input_input1 input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #b8b8b8;
}

.login_box_input_input1 input:focus {
  outline: none;
  border: 1px solid #fcad2a;
}

.login_box_input_input2 {
  width: 300px;
  height: 48px;
  position: relative;
  display: flex;
  justify-content: space-between;
}

.login_box_input_input2 input {
  width: 168px;
  height: 48px;
  background-color: #f7f7f7;
  border-radius: 6px;
  border: solid 1px #f3f3f3;
  padding-left: 24px;
}

.login_box_input_input2 img {
  width: 96px;
  height: 48px;
  border-radius: 6px;
}

.login_box_input_input2 input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #b8b8b8;
}

.login_box_input_input2 input:focus {
  outline: none;
  border: 1px solid #fcad2a;
}

.login_box_input_input3 {
  width: 300px;
  height: 48px;
  position: relative;
  display: flex;
  justify-content: space-between;
}

.login_box_input_input3 input {
  width: 168px;
  height: 48px;
  background-color: #f7f7f7;
  border-radius: 6px;
  border: solid 1px #f3f3f3;
  padding-left: 24px;
}

.login_box_input_input3_hqyzm {
  width: 96px;
  height: 48px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #ffffff;
  background-color: #d9d9d9;
  cursor: pointer;
}

.login_box_input_input3 input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #b8b8b8;
}

.login_box_input_input3 input:focus {
  outline: none;
  border: 1px solid #fcad2a;
}

#eye_zhuce1 {
  width: 21px;
  height: 13px;
  position: absolute;
  top: 15px;
  right: 24px;
  cursor: pointer;
}

#eye_zhuce1 img {
  width: 21px;
  height: 13px;
}

#eye_zhuce2 {
  width: 21px;
  height: 13px;
  position: absolute;
  top: 15px;
  right: 24px;
  cursor: pointer;
}

#eye_zhuce2 img {
  width: 21px;
  height: 13px;
}

#eye {
  width: 21px;
  height: 13px;
  position: absolute;
  top: 15px;
  right: 24px;
  cursor: pointer;
}

#eye img {
  width: 21px;
  height: 13px;
}

.login_box_input_button1 {
  width: 300px;
  height: 48px;
  background-color: #fcad2a;
  border-radius: 6px;
  /* opacity: 0.3; */
  text-align: center;
  line-height: 48px;
  font-size: 16px;
  color: #ffffff;
  margin-top: 24px;
  cursor: pointer;
}

.login_box_bottom_menu1 {
  width: 100%;
  height: 46px;
  display: flex;
  justify-content: space-between;
}

.login_box_bottom_xczddl {
  width: 12px;
  height: 12px;
  border: 1px solid #b8b8b8;
  margin-right: 4px;
  margin-bottom: -2px;
  cursor: pointer;
}

.login_box_bottom_xczddl2 {
  width: 14px;
  height: 14px;
  border: none;
  margin-right: 4px;
  margin-bottom: -2px;
  background-image: url("../../public/img/login/agree.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.login_box_bottom_menu11 {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  cursor: pointer;
}

.login_box_bottom_menu12 {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.login_box_bottom_menu12_text1 {
  color: #999999;
  cursor: pointer;
}

.login_box_bottom_menu12_text2 {
  color: #999999;
  margin-left: 3px;
  margin-right: 3px;
}

.login_box_bottom_menu12_text3 {
  color: #fcad2a;
  cursor: pointer;
}

.login_disanfang_box {
  text-align: center;
  margin-top: 40px;
}

.login_disanfang_box_text {
  font-size: 14px;
  color: #666666;
  margin-bottom: 23px;
}

.login_disanfang_box_img img {
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.login_xieyi_yinsi {
  margin-top: 30px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #666666;
  text-decoration: none;
}

.login_xieyi_yinsi_text1 {
  text-decoration: none;
  color: #fcad2a;
  cursor: pointer;
  font-style: normal;
}

.login_xieyi_yinsi_text2 {
  text-decoration: none;
  color: #fcad2a;
  cursor: pointer;
  font-style: normal;
}

.login_box_input_input6 {
  width: 300px;
  height: 86px;
  background-color: #ffffff;
  box-shadow: 0px 1px 17px 1px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  display: flex;
}

.login_box_input_input6_left {
  display: flex;
  align-items: center;
  justify-content: center;
}

.login_box_input_input6_right {
  display: flex;
  align-items: center;
  justify-content: center;
}

#yaoqing_img {
  width: 54px;
  height: 55px;
  margin-left: 20px;
  border-radius: 50%;
  margin-right: 12px;
}

#yaoqing_text1 {
  font-size: 16px;
  color: #333333;
}

#yaoqing_text2 {
  font-size: 16px;
  color: #999999;
}

.login_weixin {
  text-align: center;
  margin-top: 52px;
}
</style>
